import styled from '@emotion/styled';
import { Stack, Text } from '@hotjar/hotsauce';

export const ImageContainer = styled(Stack)`
  & img {
    width: 100%;
  }
`;

export const ThankYouDetails = styled(Stack)`
  max-width: 500px;
`;

export const StyledText = styled(Text)`
  white-space: pre-line;
`;
